import { Link, useParams } from 'wouter'

import s from './Tabs.module.css'

type Tab = {
  id: string
  label: string
  content: React.ReactNode
  action?: React.ReactNode
}

type Props = {
  tabs: Tab[]
  defaultTab: string
}

export const Tabs = ({ tabs, defaultTab }: Props) => {
  const { tab: tabId = defaultTab } = useParams()

  const tabMap = tabs.reduce<Record<string, Tab>>((res, tab) => {
    res[tab.id] = tab
    return res
  }, {})

  return (
    <div>
      <div className={s.header}>
        <div className={s.buttons}>
          {tabs.map((tab) => (
            <Link
              key={tab.label}
              href={`/organization/${tab.id}`}
              className={`${s.button} ${tab.id === tabId ? s.active : ''}`}
              replace
            >
              {tab.label}
            </Link>
          ))}
        </div>
        {tabMap[tabId]?.action}
      </div>
      {tabMap[tabId]?.content}
    </div>
  )
}
